import React, { Component } from 'react';
import FeatureTable from './FeatureTable';
import FeatureEditPanel from './FeatureEditPanel';
import FeaturePermissionsPanel from './FeaturePermissionsPanel';
import { IFeature } from './types';
import { getAllFeaturesService } from './services';

interface IProps {
    // Define your props here if needed
}

export interface IFeaturePermissionState {
    selectedFeature: IFeature | null;
    isEditPanelOpen: boolean;
    isPermissionsPanelOpen: boolean;
    features: IFeature[];
}

class FeaturePermission extends Component<IProps, IFeaturePermissionState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedFeature: null,
            isEditPanelOpen: false,
            isPermissionsPanelOpen: false,
            features: []
        };
    }

    async componentDidMount() {
        await this.loadFeatures();
    }

    private loadFeatures = async (): Promise<void> => {
        try {
            const features = await getAllFeaturesService();
            if (features && features.length > 0) {
                this.setState({ features });
            }
        } catch (error) {
            console.error('Failed to load features:', error);
        }
    };

    setStateProperty = (propertyName: keyof IFeaturePermissionState, value: any) => {
        this.setState({ [propertyName]: value } as Pick<IFeaturePermissionState, keyof IFeaturePermissionState>);
    }

    private _onEditFeature = (feature: IFeature): void => {
        this.setState({
            selectedFeature: feature,
            isEditPanelOpen: true
        });
    };

    private _onManagePermissions = (feature: IFeature): void => {
        this.setState({
            selectedFeature: feature,
            isPermissionsPanelOpen: true
        });
    };

    private _onDismissEditPanel = (): void => {
        this.setState({
            isEditPanelOpen: false,
            selectedFeature: null
        });
    };

    private _onDismissPermissionsPanel = (): void => {
        this.setState({
            isPermissionsPanelOpen: false
        });
    };

    private _onSaveFeature = (feature: IFeature): void => {
        const { features } = this.state;

        if (features.findIndex(f => f.id === feature.id) === -1) {
            // New feature - assign temporary ID
            const newFeature = { ...feature, Id: Date.now() };
            this.setState({
                features: [...features, newFeature],
                isEditPanelOpen: false,
                selectedFeature: null
            });
        } else {
            // Update existing feature
            const updatedFeatures = features.map(f =>
                f.id === feature.id ? feature : f
            );
            this.setState({
                features: updatedFeatures,
                isEditPanelOpen: false,
                selectedFeature: null
            });
        }
    };

    render() {
        const { features, selectedFeature, isEditPanelOpen, isPermissionsPanelOpen } = this.state;

        return (
            <div style={{ padding: '20px' }}>
                <FeatureTable
                    features={features}
                    onEditFeature={this._onEditFeature}
                    onManagePermissions={this._onManagePermissions}
                    onSetStateProperty={this.setStateProperty}
                />

                <FeatureEditPanel
                    isOpen={isEditPanelOpen}
                    feature={selectedFeature}
                    onDismiss={this._onDismissEditPanel}
                    onSave={this._onSaveFeature}
                />

                <FeaturePermissionsPanel
                    isOpen={isPermissionsPanelOpen}
                    feature={selectedFeature}
                    onDismiss={this._onDismissPermissionsPanel}
                />
            </div>
        );
    }
}

export default FeaturePermission;